import React from 'react';
import { mmToPx, SCREEN_DPI } from '@/types/label';

export interface AlignmentGuide {
  type: 'vertical' | 'horizontal';
  position: number; // mm
}

interface AlignmentGuidesProps {
  guides: AlignmentGuide[];
  scale: number;
}

export const AlignmentGuides: React.FC<AlignmentGuidesProps> = ({
  guides,
  scale,
}) => {
  return (
    <>
      {guides.map((guide, index) => {
        const position = mmToPx(guide.position, SCREEN_DPI) * scale;
        
        if (guide.type === 'vertical') {
          return (
            <div
              key={`v-${index}`}
              className="absolute top-0 bottom-0 pointer-events-none"
              style={{
                left: position,
                width: 1,
                backgroundColor: 'hsl(var(--destructive))',
                opacity: 0.8,
              }}
            />
          );
        }
        
        return (
          <div
            key={`h-${index}`}
            className="absolute left-0 right-0 pointer-events-none"
            style={{
              top: position,
              height: 1,
              backgroundColor: 'hsl(var(--destructive))',
              opacity: 0.8,
            }}
          />
        );
      })}
    </>
  );
};
